export default {
    test: 'hola mundo',
    loading: 'Cargando...',
    // Shown under a message the form moves past on its own (phone verified, too many attempts, Flinks retries).
    continuing: 'Continuando…',
    from_prepop_get_loan: 'Continúe con su solicitud para obtener su préstamo',
    you_were_referred_by: 'Fue referido por',
    prepop_welcome_kicker: 'Pre-calificado',
    prepop_welcome_title: '¡Ya casi llega!',
    prepop_welcome_body: 'Complete su solicitud en menos de <strong>2 minutos</strong> y desbloquee su tasa de préstamo exclusiva.',
    prepop_welcome_trust: 'Sin compromiso · 100% seguro',
    components: {
        form: {},
        field: {},
        flinks: {
            max_retry_reached: 'Se alcanzó el número máximo de intentos; pasando al siguiente paso.',
        },
        smsverification: {
            edit_phone: 'Editar teléfono',
            verify_code: 'Verificar',
            verified_success: '¡Su número de teléfono ha sido verificado exitosamente!',
            max_attempts_reached: 'Ha alcanzado el número máximo de intentos.',
            verification_code_sent: 'Recibirá un código de verificación por SMS, pueden aplicar tarifas estándar de mensajes o datos.',
            new_accounts_must_verify: 'Por razones de seguridad, las cuentas nuevas deben verificar sus números de teléfono.',
            last_attempt: 'Le queda 1 intento.',
            sent_sms_to: 'Código SMS enviado a:',
            resend_code: 'Solicitar otro código',
            resend_code_in: 'Puede solicitar otro código en',
            seconds: 'segundos',
            skip_verification_car_loan: `<small><b class="text-primary">Importante:</b> Puede omitir este paso, pero sus opciones pueden ser limitadas.</small>`,
            skip_verification_member_enrollment: `<small><b class="text-primary">Importante:</b> Puede omitir este paso presionando el botón de abajo, pero no podrá crear una cuenta.</small>`,
            enter_valid_code: 'Por favor ingrese un código de verificación válido.',
            enter_valid_phone: 'Por favor ingrese un número de teléfono válido.',
            enter_valid_phone_ca: 'Por favor ingrese un número de teléfono canadiense válido.',
            enter_valid_phone_us: 'Por favor ingrese un número de teléfono válido de EE.UU.',
            sms_code_could_not_send: "No pudimos enviar un código SMS al número proporcionado. Asegúrese de que sea correcto e intente de nuevo.",
            sms_code_is_incorrect: "El código que proporcionó es incorrecto. Por favor intente de nuevo.",
            enter_phone: 'Ingrese su número de teléfono',
            enter_code: 'Ingrese el código de verificación',
        }
    },
    validations: {
        invalid_data: 'Revise este dato.',
        postal_code_format: 'Ingrese un código postal como H2X 1Y4.',
        zip_code_format: 'Ingrese un código ZIP de 5 dígitos, como 10001.',
        required_choice: 'Elija una opción.',
        required_field: 'Complete este campo.',
        max_length: 'Este dato es demasiado largo. Acórtelo, por favor.',
        email_undeliverable: 'No pudimos verificar este correo electrónico. Revise que no tenga errores.',
        email_required: "Ingrese un correo electrónico válido, como nombre{'@'}ejemplo.com.",
        phone_format: 'Ingrese un número de teléfono de 10 dígitos.',
        phone_canadian: 'Ingrese un número de teléfono canadiense de 10 dígitos.',
        phone_us: 'Ingrese un número de teléfono de 10 dígitos.',
        password: 'La contraseña debe tener al menos 8 caracteres, contener una letra mayúscula, una minúscula y un número.',
        password_confirmation: 'Las contraseñas no coinciden.',
        email_confirmation: 'Los correos electrónicos no coinciden.',
        name: 'Use solo letras, espacios, guiones y apóstrofos.',
        dob: 'Elija su fecha de nacimiento. Debe tener 18 años o más.',
        date: 'Elija una fecha del calendario.',
        month_year: 'Seleccione un mes y un año',
        in_choices: 'Seleccione una de las opciones',
        paydate: 'Elija una fecha de pago entre mañana y dentro de 3 meses.',
        sin: 'Ingrese su SIN de 9 dígitos.',
        invalid_character: 'Quite los caracteres especiales.',
        numeric: 'Ingrese solo números.',
        car_year: 'Ingrese el año del auto, por ejemplo 2018.',
        rate: 'Ingrese su tasa como un número, por ejemplo 7 o 6.99.',
        drivers_license: 'Debe tener 18 años o más y poseer una licencia de conducir para calificar para un préstamo de auto',
        address_required: 'Ingrese su dirección.',
        property_mortgage: 'La hipoteca debe ser menor que el valor de la propiedad'
    },
    steps: {
        titles: {
            requested_amount_business: 'Monto de financiamiento deseado',
            requested_amount: '¿Cuánto le gustaría pedir prestado?',
            requested_amount_debt: '¿Cuánto necesita para consolidar su deuda?',
            product_purpose: '¿Cuál es el propósito del préstamo?',
            cc_debt_amount: 'Monto de deuda de tarjeta de crédito',
            unsecured_debt_amount: 'Total de otras deudas no garantizadas',
            in_credit_situation: '¿Cuál es su puntaje de crédito estimado?',
            income_type: 'Seleccione su principal fuente de ingresos',
            current_income_source: '¿Cuál es su fuente de ingresos actual?',
            income_type_other: '¿Tiene otras fuentes de ingresos? <br><small>Seleccione todas las que apliquen</small>',
            direct_deposit: '¿Recibe sus ingresos por depósito directo?',
            gross_monthly_income: '¿Cuál es su ingreso mensual bruto?',
            monthly_income: 'Seleccione su ingreso mensual',
            monthly_income_input: 'Ingrese su ingreso mensual',
            monthly_other_income_input: 'Ingrese su ingreso mensual',
            address: '¿Cuál es su dirección?',
            address_length_months: '¿Cuánto tiempo lleva en esta dirección?',
            address_length_months_current: '¿Cuánto tiempo lleva en su dirección actual?',
            own_home: '¿Es propietario de vivienda?',
            living_situation: 'Cuéntenos sobre su situación de vivienda',
            dob: '¿Cuál es su fecha de nacimiento?',
            employer_information: 'Por favor ingrese su información de empleo',
            employed_months: '¿Cuánto tiempo lleva en este trabajo?',
            employed_months_how_long: '¿Cuánto tiempo ha estado empleado?',
            pay_frequency: '¿Con qué frecuencia le pagan?',
            pay_date1: '¿Cuál es su próxima fecha de pago?',
            flinks_personal_loan: 'Seleccione la cuenta bancaria donde desea que se deposite su dinero',
            flinks_car_loan: 'Confirme la cuenta con la que desea realizar sus pagos de auto',
            flinks_powersports: 'Confirme la cuenta con la que desea realizar sus pagos',
            how_to_contact: '¿Cómo podemos comunicarnos con usted?',
            phone_verification: 'Verificación de teléfono',
            lets_create_your_account: '¡Creemos su cuenta!',
            create_comparehub_account: '¿Desea crear una cuenta con nosotros?',
            citizen_status: 'Seleccione su estatus de ciudadanía',
            credit_card_debt_amount: 'Monto de deuda de tarjeta de crédito',
            is_last_step: '¡Este es el último paso!',
            wants_equifax_verification: '¿Desea verificarse con Equifax para obtener su puntaje de crédito y reporte GRATIS?',
            confirm_information: 'Por favor confirme su información a continuación antes de continuar',
            sms_verification: 'Por favor confirme su número de teléfono con el código de verificación que se enviará a su teléfono',
            lets_get_you_approved: '¡Consigamos su aprobación!',
            postal_code: 'Ingrese su código postal',
            zip: 'Ingrese su código postal',
            ssn: 'Número de Seguro Social',
            in_military: '¿Es militar o tiene conexión militar?',
            bank_account_type: '¿Dónde le gustaría recibir sus fondos?',
            bank_account_details: '¿Dónde le gustaría recibir sus fondos?',
            drivers_license: 'Licencia de conducir',
            phone_number_work: 'Teléfono de trabajo',

            // car loan application
            car_request_type: 'Seleccione el tipo de auto que desea comprar',
            car_request_monthly_budget: '¿Cuál es su presupuesto mensual?',
            car_in_credit_situation: '¿Cuál es su puntaje de crédito estimado?',
            car_request_sms_verification_code: 'Por favor verifique su preferencia de vehículo solicitando un código de verificación por teléfono',

            // life insurance
            requested_amount_life_insurance: '¿Cuánta cobertura le gustaría?',
            what_province: '¿En qué provincia vive?',
            select_gender: 'Seleccione su género',
            were_you_born_male_or_female: '¿Nació hombre o mujer?',
            title_salutation: 'Saludo',
            what_is_your_name: '¿Cuál es su nombre?',
            do_you_smoke_or_vape: '¿Fuma o vapea?',

            // powersports
            what_are_you_looking_for: '¿Qué está buscando comprar?',
            requested_amount_powersports: '¿Cuál es el valor del artículo que desea financiar?',

            // business loan
            business_start_date: 'Fecha de inicio del negocio (estimada)',
            equity: 'Capital',
            business_assets: 'Activos del negocio',
            company_information: 'Información de la empresa',
            average_monthly_revenue: 'Ingresos mensuales promedio',
            notice_of_assessment: 'Aviso de evaluación (NOA)',
            // TODO(review): Spanish drafts for the v2 business form
            purpose_of_funds: '¿Para qué usará los fondos?',
            has_business_bank_account: '¿El negocio tiene su propia cuenta bancaria?',
            ownership_percentage: '¿Qué parte del negocio le pertenece?',
            insolvency_consultation: '¿Alguna vez ha consultado a un síndico de insolvencia autorizado o a un consejero de crédito?',
            // TODO(review)
            monthly_mortgage_payment: '¿Cuál es su pago mensual de hipoteca?',
            monthly_rent: '¿Cuál es su alquiler mensual?',
            // debt / financial profile
            in_bankruptcy: '¿Se encuentra actualmente en quiebra?',
            in_dmp: '¿Se encuentra actualmente en un programa de gestión de deudas?',
            in_consumer_proposal: '¿Se encuentra actualmente en una propuesta de consumidor?',
            // car refinancing
            lower_car_loan_payments: `<h3 class="my-3 text-center h2">Reduzca sus pagos de préstamo de auto</h3>`,
            tell_us_about_current_vehicle: 'Cuéntenos sobre su vehículo actual',
            tell_us_about_current_financing: 'Cuéntenos sobre su financiamiento de auto actual',
            do_you_have_proof_of_income: '¿Tiene comprobante de ingresos?',
            //heloc
            more_information_needed: '<h4 class="text-center col-md-10 mx-auto">Solo necesitamos un poco más de información para continuar...</h4>'
        },
        textTop: {
            hard_credit_check: `<div class="col-md-12 py-2" style="margin-top:30px;">Para maximizar sus posibilidades de encontrar un proveedor de servicios, le recomendamos que autorice a nuestra red de proveedores a obtener informes de crédito de las agencias de informes crediticios para evaluar su historial de crédito y tomar decisiones de aprobación. Al seleccionar "<b class="text-secondary">Maximizar mis posibilidades de aprobación</b>" los proveedores coincidentes pueden revisar su informe de crédito para tomar decisiones de aprobación completas basadas en su solicitud y usted puede ser financiado más rápido. De lo contrario, acepta que su consentimiento se limita solo a una verificación de crédito suave y que está limitando sus oportunidades de aprobación. Su consentimiento es válido hasta que notifique al proveedor coincidente de su retiro de consentimiento.</div>`,
            unsecured_debt_amount_definition: `<p class="text-muted my-3 text-center">La deuda no garantizada se refiere a préstamos de día de pago o personales y facturas de telecomunicaciones, pero excluye saldos de tarjetas de crédito, préstamos de auto e hipotecas.</p>`,
            create_comparehub_account_benefits: `
                <p>Al crear una cuenta puede:
                    <ul>
                        <li>Aumentar sus posibilidades de calificación</li>
                        <li>Seguir el historial de sus solicitudes</li>
                        <li>Acelerar solicitudes futuras</li>
                        <li><b>¡Obtenga su puntaje de crédito Equifax gratis!</b></li>
                    </ul>
                </p>
                <h6 class="text-center text-dark mt-3">Crear su cuenta de puntaje de crédito gratis no afectará su crédito</h6>
            `,
            get_options_with_consent: `<p class="text-muted h5 my-3 text-center">¿Está listo para recibir sus recomendaciones por mensajes electrónicos y ver sus opciones de préstamo?</p>`,
            prequalify_best_providers: `<h6 class="text-center text-dark mt-3">Continuar nos ayudará a precalificarlo con los mejores proveedores</h6>`,
        },
        textBottom: {
            flinks_skip: '<div class="text-center col-md-12 py-2" style="margin-top:30px;"><b class="text-primary">Importante:</b> Puede omitir este paso presionando el botón de abajo, sin embargo sus posibilidades de aprobación pueden verse afectadas.<br><br><small>Al proporcionar sus datos de acceso bancario, confirma que está al tanto de cualquier obligación contractual con su institución financiera.</small></div>',
            comparehub_member_pp_tc: `Al crear una cuenta se convertirá en miembro de CompareHub y tendrá acceso a recursos educativos, recomendaciones personalizadas y la opción de obtener su puntaje de crédito Equifax gratis. Para más información, revise nuestra <a href="https://loanscanada.ca/privacy-policy/" target="_blank">Política de privacidad</a> y <a href="https://loanscanada.ca/terms/" target="_blank">Términos de uso</a>. Esto no afecta su puntaje de crédito.`,
            create_comparehub_account_opt_in: `<p class="text-muted small">Al crear una cuenta se convertirá en miembro de CompareHub y tendrá acceso a recursos educativos, recomendaciones personalizadas y la opción de obtener su puntaje de crédito Equifax gratis. Para más información, revise nuestra <a href="https://loanscanada.ca/privacy-policy/" target="_blank">Política de privacidad</a> y <a href="https://loanscanada.ca/terms/" target="_blank">Términos de uso</a>. <b>Esto no afecta su puntaje de crédito.</b></p>`,
            consent_text: `<p class="text-muted text-center my-3"><small>Al completar este formulario, autorizo al proveedor de servicios financieros de confianza con el que he sido emparejado a obtener informes de crédito de las agencias de informes crediticios para evaluar mi historial de crédito (esto no afectará su puntaje de crédito). Mi consentimiento es válido hasta que notifique al proveedor emparejado de su retiro.</small></p>`,
            opt_in_text: `<p class="text-muted text-center my-3"><small>Al seleccionar 'Sí', acepta recibir promociones y actualizaciones de {brand} y CompareHub.</small></p>`,
            us_consent: `<p class="text-center" style="font-size:13px; color:#6b7280;">Al hacer clic en "Siguiente", acepto los <a href="https://app.reboundfinance.com/terms/" target="_blank">Términos de uso</a> y la <a href="https://app.reboundfinance.com/privacy-policy/" target="_blank">Política de privacidad</a> y autorizo a Rebound Finance y sus socios de marketing, incluyendo los prestamistas y proveedores de servicios listados <a href="#" class="partners-disclosure-btn" onclick="window.showPartnersList()">aquí</a>, a contactarme al número y correo electrónico que proporcioné, incluyendo mediante: llamadas automáticas, voces artificiales o pregrabadas, mensajes de texto (SMS/MMS) y correo electrónico. Pueden aplicar tarifas de mensajes y datos (puede responder "STOP" para cancelar). No estoy obligado a obtener bienes o servicios ni a ser conectado con ninguno de los proveedores de servicios que puedan satisfacer mis necesidades. Además, al proporcionar mi correo electrónico, autorizo y doy a Rebound Finance mi consentimiento expreso por escrito para recibir comunicaciones electrónicas, incluyendo correos periódicos con noticias importantes, consejos financieros, herramientas, promociones (incluyendo ofertas de terceros) y más de Rebound Finance. Entiendo que siempre puedo retirar mi consentimiento o cancelar mi suscripción en cualquier momento.</p>`,
        },
        textBottomBelowActionButtons: {
            terms_privacy_consent: `
                <p style="font-size:13px; color:#6b7280;">{terms_privacy_consent}</p>
            `,
            credit_history_authorization_1: `
                <p style="font-size:13px; color:#6b7280;">{credit_history_authorization_1}</p>
            `,
            credit_history_authorization_1_car_loan: `
                <p style="font-size:13px; color:#6b7280;">{credit_history_authorization_1_car_loan}</p>
            `,
            credit_history_authorization_1_car_refinancing: `
                <p style="font-size:13px; color:#6b7280;">{credit_history_authorization_1_car_refinancing}</p>
            `,
            credit_history_authorization_1_insurance: `
                <p style="font-size:13px; color:#6b7280;">{credit_history_authorization_1_insurance}</p>
            `,
            rebound_consent_heloc: `<p class="text-center" style="font-size:13px; color:#6b7280;">Al hacer clic en "Siguiente", acepto los <a href="https://app.reboundfinance.com/terms/" target="_blank">Términos de uso</a> y la <a href="https://app.reboundfinance.com/privacy-policy/" target="_blank">Política de privacidad</a> y autorizo a Rebound Finance y sus socios de marketing, incluyendo los prestamistas y proveedores de servicios listados <a href="#" class="partners-disclosure-btn" onclick="window.showPartnersList()">aquí</a>, a contactarme al número y correo electrónico que proporcioné, incluyendo mediante: llamadas automáticas, voces artificiales o pregrabadas, mensajes de texto (SMS/MMS) y correo electrónico. Pueden aplicar tarifas de mensajes y datos (puede responder "STOP" para cancelar). No estoy obligado a obtener bienes o servicios ni a ser conectado con ninguno de los proveedores de servicios que puedan satisfacer mis necesidades. Además, al proporcionar mi correo electrónico, autorizo y doy a Rebound Finance mi consentimiento expreso por escrito para recibir comunicaciones electrónicas, incluyendo correos periódicos con noticias importantes, consejos financieros, herramientas, promociones (incluyendo ofertas de terceros) y más de Rebound Finance. Entiendo que siempre puedo retirar mi consentimiento o cancelar mi suscripción en cualquier momento.</p>`
        },
        hint: {
            // TODO(review): Spanish draft for the v2 business form
            business_start_date_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">La mayoría de los prestamistas requiere que el negocio haya estado operando y generando ingresos durante al menos 6 meses.</p>`,
            average_monthly_revenue_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Todo lo que su negocio recibe cada mes, antes de gastos.<span class="d-block mt-1">La mayoría de los prestamistas requiere al menos <b>$10,000</b> en ventas totales verificables al mes.</span></p>`,
            business_structure_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;"><b>Corporación:</b> el nombre termina en Inc., Ltd. o Corp.<br><b>Empresa individual:</b> nunca se incorporó (trabaja por cuenta propia o registró un nombre comercial).<br><b>Sociedad:</b> dos o más dueños, sin incorporar.<span class="d-block mt-1"><em>¿No está seguro? Elija "Otro / no estoy seguro", no detendrá su solicitud.</em></span></p>`,
            hard_credit_check_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Para maximizar sus posibilidades de encontrar un proveedor de servicios, le recomendamos autorizar a nuestra red de proveedores con permiso para obtener informes de crédito de agencias de informes crediticios para evaluar su historial de crédito y tomar decisiones de aprobación. Al seleccionar "<b class="text-secondary">Maximizar mis posibilidades de aprobación</b>" los proveedores asignados pueden verificar su informe de crédito para tomar decisiones de aprobación completas basadas en su solicitud y puede ser financiado más rápido. De lo contrario, acepta que su consentimiento se limita solo a una verificación de crédito suave y está limitando sus oportunidades de aprobación. Su consentimiento es válido hasta que notifique al proveedor asignado del retiro de su consentimiento.</p>`,
            unsecured_debt_amount_definition_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">La deuda no garantizada se refiere a préstamos de día de pago o personales y facturas de telecomunicaciones, pero excluye saldos de tarjetas de crédito, préstamos de auto e hipotecas.</p>`,
            bank_account_type_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Los prestamistas tienen más probabilidades de aprobar a solicitantes con una cuenta de cheques.</p>`,
            driver_license_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Su identificación estatal o número de licencia de conducir se usa para verificar su identidad y protegerlo contra fraude.</p>`,
            work_phone_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Requerido por la mayoría de los prestamistas. Su empleador nunca será contactado sobre su solicitud de préstamo. Si no está empleado actualmente, proporcione el número de teléfono de la organización o agencia donde recibe beneficios.</p>`,
            ssn_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Su SSN se usa para verificar su identidad. Toda la información está encriptada y se elimina automáticamente dentro de los 7 días posteriores a la presentación.</p>`,
            employer_information_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Recopilamos detalles de empleo para verificar ingresos y acelerar la aprobación de su préstamo. Si recibe beneficios, ingrese el nombre de la agencia u organización.</p>`,
            employed_months_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Esto nos ayuda a entender su situación financiera y ofrecer opciones que se ajusten a sus necesidades. Si no está empleado actualmente, díganos cuánto tiempo trabajó en su empleo anterior.</p>`,
            pay_frequency_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Si no está empleado actualmente, díganos con qué frecuencia recibe beneficios o ingresos.</p>`,
            gross_monthly_income_hint: `<p class="text-muted mb-0" style="font-size: 0.9rem;">Incluya su ingreso total disponible de todas las fuentes. Esto puede incluir empleo, beneficios, pensiones, inversiones, ingresos por alquiler e ingresos por trabajo independiente.</p>`,
            void_check: `<div style="max-width: 75%; margin: 0 auto;"><img src="/assets/images/hints/void-check.png" class="img-fluid mb-2" alt="Ejemplo de cheque anulado" /></div>`,
        },
        notice: {
            prepop_contact_greeting: '¡Estás a un paso de la aprobación!<br><small>Confirma tus datos abajo para continuar.</small>',
            prepop_confirm_address: 'Asegúrate de que tu dirección sea correcta para encontrarte las mejores ofertas',
            prepop_verify_phone: '¡Ya casi estás! Verifica tu teléfono para desbloquear tus ofertas de préstamo personalizadas',
        },
    },
    fields: {
        help: {
            round_rate: 'Redondee a un entero (6.99 % → 7).',
        },
        labels: {
            requested_amount: '¿Cuánto le gustaría pedir prestado?',
            rent_mortgage_payment: 'Pago de alquiler/hipoteca',
            monthly_rent_or_mortgage_payment: 'Pago mensual de alquiler o hipoteca (ingrese 0 si no aplica)',
            property_value: 'Valor de la propiedad',
            property_mortgage: 'Hipoteca de la propiedad',
            first_name: 'Nombre',
            last_name: 'Apellido',
            email_address: 'Correo electrónico',
            confirm_email: 'Confirme su correo electrónico',
            phone: 'Teléfono',
            phone_number: 'Número de teléfono',
            employer_name: 'Nombre del empleador',
            job_title: 'Ocupación',
            phone_number_work: 'Teléfono de trabajo',
            address_civic_number: 'Número cívico',
            address_street: 'Calle',
            address_unit_number: 'Número de unidad',
            address_postal_code: 'Código postal',
            address_zip: 'Código postal',
            address_city: 'Ciudad',
            address_province: 'Provincia',
            address_state: 'Estado',
            password: 'Contraseña',
            confirm_password: 'Confirme su contraseña',
            dob: '¿Cuál es su fecha de nacimiento?',
            sin_optional: 'SIN (Opcional)',
            your_address: 'Su dirección',
            answer_not_provided: 'La respuesta no fue proporcionada.',
            monthly_income: 'Ingreso mensual',
            monthly_income_employment: 'Ingreso mensual de empleo',
            monthly_income_pension: 'Ingreso mensual de jubilación',
            monthly_other_income: 'Otros ingresos mensuales',
            postal_code: 'Código postal',
            zip: 'Código postal',
            province: 'Provincia',
            state: 'Estado',
            last_years_income: 'Ingreso del año pasado',
            year_before_last_income: 'Ingreso del año anterior al pasado',
            liquid_equity: `Capital líquido <br>(efectivo, acciones, bonos, ETFs)`,
            non_liquid_equity: `Capital no líquido <br>(equipo, bienes raíces, vehículos)`,
            company_name: 'Nombre de la empresa',
            gross_sales_monthly: 'Ventas brutas (mensuales)',
            gross_sales_cards: 'Ventas brutas (solo tarjetas)',
            average_monthly_sales: 'Ventas mensuales promedio',
            average_monthly_sales_cards: 'Ventas mensuales promedio de crédito/débito',
            industry: 'Industria',
            payment_processor: '¿Quién es su procesador de pagos?',
            business_structure: `Estructura legal del negocio <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" class="text-secondary ms-1 align-text-bottom" style="width: 0.9rem; height: 0.9rem;" role="img" aria-label="Vea la nota de arriba"><title>Vea la nota de arriba</title><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>`,
            number_of_employees: 'Número de empleados, incluyéndolo a usted',
            // car refinancing
            car_ownership_status: 'Estado de propiedad del auto',
            car_value: 'Valor del auto',
            car_refinancing_balance: 'Saldo de financiamiento del auto',
            car_year: 'Año del auto',
            car_mileage: 'Kilometraje del auto (KMs)',
            car_make: 'Marca del auto',
            car_model: 'Modelo del auto',
            car_current_lender: 'Prestamista actual',
            car_current_loan_rate: 'Tasa de préstamo actual',
            car_current_loan_monthly_payment: 'Pago mensual',
            car_loan_remaining_months: 'Meses restantes',
            title_salutation: "Saludo",
            // debt / financial profile
            in_bankruptcy: '¿Se encuentra actualmente en quiebra?',
            in_dmp: '¿Se encuentra actualmente en un programa de gestión de deudas?',
            in_consumer_proposal: '¿Se encuentra actualmente en una propuesta de consumidor?',
            business_start_date: 'Fecha de inicio del negocio',
            routing_number: 'Número de ruta',
            account_number: 'Número de cuenta',
            bank_name: 'Nombre del banco',
            bank_account_length_months: '¿Cuánto tiempo ha tenido esta cuenta?',
            license_id: 'ID o número de licencia',
            license_state: 'Estado de la licencia',
            employed_months: '¿Cuánto tiempo lleva en este trabajo?',
        },
        options: {
            opt_yes: "Sí",
            opt_no: "No",
            opt_not_right_now: "No en este momento",
            //requested_amount
            opt_1000_less: "$1,000 o menos",
            opt_1001_5000: "$1,001 a $5,000",
            opt_5001_10000: "$5,001 a $10,000",
            opt_10001_15000: "$10,001 a $15,000",
            opt_15001_20000: "$15,001 a $20,000",
            opt_20000_more: "Más de $20,000",
            opt_20001_50000: "$20,001 a $50,000",
            opt_50000_more: "Más de $50,000",
            opt_amount_1001_2000: "$1,001 a $2,000",
            opt_amount_2001_3000: "$2,001 a $3,000",
            opt_amount_3001_4000: "$3,001 a $4,000",
            opt_amount_4001_5000: "$4,001 a $5,000",
            opt_amount_2001_5000: "$2,001 a $5,000",
            // product_purpose
            opt_debt_consolidation: "Consolidación de deudas",
            opt_cc_consolidation: "Consolidación de tarjetas de crédito",
            opt_emergency_expense: "Gasto de emergencia",
            opt_car_repair: "Reparación de auto",
            opt_other: "Otro",
            // cc_debt_amount
            // unsecured_debt_amount
            opt_debt_no_cc_debt: "Sin deuda de tarjeta de crédito",
            opt_debt_no_unsecured_debt: "Sin otra deuda no garantizada",
            opt_debt_amounts_2500_less: "Menos de $2,500",
            opt_debt_amounts_2501_5000: "$2,501 a $5,000",
            opt_debt_amounts_5001_10000: "$5,001 a $10,000",
            opt_debt_amounts_10001_15000: "$10,001 a $15,000",
            opt_debt_amounts_15001_20000: "$15,001 a $20,000",
            opt_debt_amounts_20001_25000: "$20,001 a $25,000",
            opt_debt_amounts_25000_more: "Más de $25,000",
            // in_credit_situation
            opt_in_credit_situation_good: "Bueno (Más de 700)",
            opt_in_credit_situation_fair: "Regular (550 - 700)",
            opt_in_credit_situation_low: "Bajo (Menos de 550)",
            opt_in_credit_situation_cp: "Propuesta de consumidor actual",
            opt_in_credit_situation_bk: "Bancarrota actual",
            opt_in_credit_situation_unknown: "No estoy seguro",
            // income_type
            opt_income_type_full: "Empleado tiempo completo",
            opt_income_type_part: "Empleado tiempo parcial",
            opt_income_type_self: "Trabajador independiente",
            opt_income_type_benefits: "Beneficios fiscales por hijos / Seguro de empleo",
            opt_income_type_disability: "Discapacidad",
            opt_income_type_pension: "Pensión / CPP / OAS",
            opt_income_type_unemployed: "Sin empleo",
            opt_income_type_other: "Otro",
            //other income types
            opt_income_type_other_wsib: "WSIB",
            opt_income_type_other_short_term_disability: "Discapacidad a corto plazo",
            opt_income_type_other_long_term_disability: "Discapacidad a largo plazo",
            opt_income_type_other_social_security: "Seguro de empleo",
            opt_income_type_other_child_tax_benefit: "Beneficio fiscal por hijos",
            opt_income_type_other_rental_income: "Ingreso por alquiler",
            opt_income_type_other_other: "Otro",
            opt_income_type_other_none: "Ninguno",
            // monthly_income
            opt_1500_less: "$1500 o menos",
            opt_1501_2000: "$1501 a $2000",
            opt_2001_3000: "$2001 a $3000",
            opt_3001_4000: "$3001 a $4000",
            opt_4001_5000: "$4001 a $5000",
            opt_5000_more: "Más de $5000",
            // employed_months
            opt_employed_months_3_less: "Menos de 3 meses",
            opt_employed_months_3_6: "3 a 6 meses",
            opt_employed_months_6_12: "6 a 12 meses",
            opt_employed_months_12_more: "1 año o más",
            // pay_frequency
            opt_weekly: "Semanal",
            opt_bi_weekly: "Quincenal",
            opt_semi_monthly: "Dos veces al mes",
            opt_monthly: "Mensual",
            // address_length_months
            opt_address_length_months_3_less: "Menos de 3 meses",
            opt_address_length_months_3_6: "3 a 6 meses",
            opt_address_length_months_6_12: "6 a 12 meses",
            opt_address_length_months_12_more: "1 año o más",
            // opt_in & credit consent
            opt_opt_in_consent: `Recibir promociones y actualizaciones de {brand} por correo electrónico. Puede cancelar en cualquier momento. Al hacer clic en 'Siguiente' acepta los <a href="https://loanscanada.ca/terms/" target="_blank">términos de uso</a> y la <a href="https://loanscanada.ca/privacy-policy/" target="_blank">política de privacidad</a>.`,
            opt_opt_in_consent_by_lc: `Recibir promociones y actualizaciones de {brand} por Loans Canada por correo electrónico. Puede cancelar en cualquier momento. Al hacer clic en 'Siguiente' acepta los <a href="https://loanscanada.ca/terms/" target="_blank">términos de uso</a> y la <a href="https://loanscanada.ca/privacy-policy/" target="_blank">política de privacidad</a>.`,
            opt_opt_in_consent_by_comparehub: `Recibir promociones y actualizaciones de {brand} por CompareHub por correo electrónico. Puede cancelar en cualquier momento. Al hacer clic en 'Siguiente' acepta los <a href="https://loanscanada.ca/terms/" target="_blank">términos de uso</a> y la <a href="https://loanscanada.ca/privacy-policy/" target="_blank">política de privacidad</a>.`,
            opt_credit_auth_1: 'Muéstreme otras opciones',
            opt_credit_auth_2: 'Maximizar mis posibilidades de aprobación',
            // canadian status
            opt_cs_citizen: "Ciudadano",
            opt_cs_permanent: "Residente permanente",
            opt_cs_work: "Permiso de trabajo",
            opt_cs_student: "Visa de estudiante",
            opt_cs_visitor: "Visitante",
            opt_cs_other: "Otro",
            // options_opt_in
            opt_continue_with_consent_yes: "¡Sí, y muéstreme mis opciones de préstamo!",
            opt_continue_with_consent_no: "Continuar solo a mis opciones de préstamo",
            // car_request_type
            opt_car_type_sedan: 'Auto',
            opt_car_type_suv: 'SUV',
            opt_car_type_van: 'Van',
            opt_car_type_truck: 'Camioneta',
            // car_request_monthly_budget
            opt_car_budget_200_less: 'Hasta $200',
            opt_car_budget_201_350: '$201 a $350',
            opt_car_budget_351_500: '$351 a $500',
            opt_car_budget_501_more: '$501 o más',
            // life insurance
            //requested_amount
            opt_100k_less: "$100,000 o menos",
            opt_100k_250k: "$100,001 a $250,000",
            opt_250k_500k: "$250,001 a $500,000",
            opt_500k_1m: "$500,001 a $1,000,000",
            opt_1m_more: "Más de $1,000,000",
            // title
            opt_title_male: "Masculino",
            opt_title_female: "Femenino",
            // powersports
            opt_powersports_rv: "Vehículos recreativos",
            opt_powersports_boat: "Botes",
            opt_powersports_tractor: "Tractores de jardín",
            opt_powersports_atv: "Vehículos todo terreno (ATVs)",
            opt_powersports_motorcycle: "Motocicletas",
            opt_powersports_snowmobile: "Motos de nieve",
            opt_powersports_ebike: "Bicicletas eléctricas",
            opt_powersports_personalwatercraft: 'Motos acuáticas <span style="font-size: 0.75rem; display:block;">(ej., Jet Skis, Sea-Doos, Botes)</span>',
            opt_powersports_camper: "Casas rodantes",
            opt_powersports_heavyequipment: "Equipo pesado",
            // business loan
            // - business_type "Other" on the POS financing form
            opt_business_type_other: "OTRO",
            // - business_type, formularios de negocios y procesamiento de pagos (15 sectores) TODO(review)
            opt_business_industry_automotive: "Automotriz (reparación, concesionario, lavado de autos)",
            opt_business_industry_beauty: "Salón de belleza, barbería o spa",
            opt_business_industry_cannabis: "Tienda de cannabis, vapeo o tabaco",
            opt_business_industry_construction: "Construcción y oficios",
            opt_business_industry_recreation: "Entretenimiento, gimnasio y recreación",
            opt_business_industry_health: "Salud y servicios médicos",
            opt_business_industry_manufacturing: "Manufactura y venta al por mayor",
            opt_business_industry_online_store: "Tienda en línea / comercio electrónico",
            opt_business_industry_professional_services: "Servicios profesionales y empresariales (legal, contabilidad, finanzas, seguros, consultoría, marketing)",
            opt_business_industry_real_estate: "Bienes raíces",
            opt_business_industry_restaurant: "Restaurante, café o bar",
            opt_business_industry_retail: "Tienda minorista",
            opt_business_industry_technology: "Tecnología y TI",
            opt_business_industry_transportation: "Transporte y camiones",
            opt_business_industry_other: "Otro",
            // - business_structure (explicaciones en steps.hint.business_structure_hint)
            opt_business_structure_corporation: "Corporación",
            opt_business_structure_sole_proprietorship: "Empresa individual",
            opt_business_structure_general_partnership: "Sociedad",
            opt_business_structure_limited_partnership: "Sociedad limitada (LP)",
            opt_business_structure_non_profit: "Sin fines de lucro o caridad",
            opt_business_structure_other: "Otro / no estoy seguro",
            // - ownership_percentage
            opt_ownership_percentage_100: "Soy el único dueño",
            opt_ownership_percentage_51: "Más de la mitad",
            opt_ownership_percentage_50: "Exactamente la mitad",
            opt_ownership_percentage_1: "Menos de la mitad",
            // - rent_mortgage_payment (montos representativos; propietarios e inquilinos ven rangos distintos) TODO(review)
            opt_rent_mortgage_payment_0_owner: "Sin hipoteca, está pagada",
            opt_rent_mortgage_payment_0_renter: "No pago alquiler",
            opt_rent_mortgage_payment_250: "Menos de $500",
            opt_rent_mortgage_payment_625: "$500 a $749",
            opt_rent_mortgage_payment_750: "$500 a $999",
            opt_rent_mortgage_payment_875: "$750 a $999",
            opt_rent_mortgage_payment_1250: "$1,000 a $1,499",
            opt_rent_mortgage_payment_1800: "$1,500 o más",
            opt_rent_mortgage_payment_2000: "$1,500 a $2,499",
            opt_rent_mortgage_payment_3000: "$2,500 o más",
            // - insolvency_consultation
            opt_insolvency_consultation_none: "No, nunca",
            opt_insolvency_consultation_within_6_months: "Sí, en los últimos 6 meses",
            opt_insolvency_consultation_over_6_months: "Sí, hace más de 6 meses",
            // - product_purpose (business)
            opt_business_purpose_everyday_operations: "Operaciones diarias y flujo de caja",
            opt_business_purpose_purchase_inventory: "Comprar inventario o materiales",
            opt_business_purpose_purchase_new_equipment: "Comprar o reparar equipo",
            opt_business_purpose_expansion: "Expandir o abrir una nueva sucursal",
            opt_business_purpose_renovations: "Renovaciones",
            opt_business_purpose_sales_and_marketing: "Ventas y marketing",
            opt_business_purpose_hire_or_pay_staff: "Contratar o pagar personal",
            opt_business_purpose_invest_in_technology: "Invertir en tecnología",
            opt_business_purpose_start_a_business: "Iniciar un nuevo negocio",
            opt_business_purpose_other: "Otro",
            // - number_of_employees
            opt_number_of_employees_1: "Solo yo",
            opt_number_of_employees_2_5: "2 a 5",
            opt_number_of_employees_6_10: "6 a 10",
            opt_number_of_employees_11_50: "11 a 50",
            opt_number_of_employees_51_plus: "51 o más",
            // - business_type (POS)
            opt_business_type_pos_retail: "COMERCIO MINORISTA",
            opt_business_type_pos_home_improvement: "MEJORAS DEL HOGAR",
            opt_business_type_pos_powersports: "DEPORTES MOTORIZADOS",
            opt_business_type_pos_automotive: "AUTOMOTRIZ",
            opt_business_type_pos_healthcare: "SALUD",
            // - payment_processor
            opt_business_payment_processor_chase_paymentech: "CHASE PAYMENTECH",
            opt_business_payment_processor_debitech: "DEBITECH",
            opt_business_payment_processor_desjardins: "DESJARDINS",
            opt_business_payment_processor_elavon: "ELAVON",
            opt_business_payment_processor_everlink: "EVERLINK",
            opt_business_payment_processor_first_data: "FIRST DATA",
            opt_business_payment_processor_global_payments: "GLOBAL PAYMENTS",
            opt_business_payment_processor_mercury_payments: "MERCURY PAYMENTS",
            opt_business_payment_processor_moneris: "MONERIS",
            opt_business_payment_processor_monex: "MONEX",
            opt_business_payment_processor_payfirma: "PAYFIRMA",
            opt_business_payment_processor_pivotal_payments: "PIVOTAL PAYMENTS",
            opt_business_payment_processor_pos_west: "POS WEST",
            opt_business_payment_processor_square: "SQUARE",
            opt_business_payment_processor_stripe: "STRIPE",
            opt_business_payment_processor_td_merchant_services: "TD MERCHANT SERVICES",
            opt_business_payment_processor_other: "OTRO",
            opt_business_payment_processor_none: "NINGUNO",
            // car refinancing
            // own_car
            opt_car_refinancing_own: 'Propio',
            opt_car_refinancing_finance: 'Financiado',
            opt_car_refinancing_lease: 'Arrendamiento',
            // US income types
            opt_income_type_employed: 'Empleado',
            opt_income_type_social_security: 'Beneficios',
            // US bank account
            opt_bank_checking: 'Cuenta de cheques',
            opt_bank_savings: 'Cuenta de ahorros',
            opt_bank_none: "No tengo cuenta bancaria",
            opt_bank_length_1_less: 'Menos de 1 mes',
            opt_bank_length_1_3: '1-3 meses',
            opt_bank_length_3_6: '3-6 meses',
            opt_bank_length_6_12: '6-12 meses',
            opt_bank_length_1_2_years: '1-2 años',
            opt_bank_length_2_5_years: '2-5 años',
            opt_bank_length_5_more: 'Más de 5 años',
        },
        placeholders: {
            select: "Seleccionar...",
            your_email: "su@correo.com",
            income_type: "Seleccione su principal fuente de ingresos...",
            income_type_other: "Por favor especifique...",
            type_to_search: "Escriba para buscar...",
            address_number: 'Número',
            address_street: 'Calle',
            address_unit: 'Apt 8, Suite 2, etc. (opcional)',
            address_city: "Ciudad",
            select_date: "Seleccionar fecha...",
            date_format: "AAAA-MM-DD",
            select_month: "Seleccionar mes y año...",
            // car refinancing
            your_current_lender: 'Su prestamista actual',
            // US banking / driver's license
            routing_number: 'Número de ruta',
            account_number: 'Número de cuenta',
            bank_name: 'Nombre del banco',
            drivers_license_number: "Número de licencia de conducir",
        },
        textBottom: {
            phone_number_sms_results: '<small style="display: block; font-size: 0.7em; padding-left: 2px; margin-top: -14px;">Recibirá un SMS único con sus resultados (responda "STOP" para cancelar).</small>'
        }
    },
    submissionLoading: {
        searching_providers: 'Buscando las mejores opciones...',
        evaluating_options: 'Evaluando sus opciones...',
        do_not_refresh: 'Por favor, no actualice la página',
        almost_there: '¡Ya casi! Encontrando los mejores resultados para usted...',
        do_not_leave: 'Por favor, no abandone esta página',
        options_available: '¡Buenas noticias! Hay opciones disponibles en su área',
    },
    buttons: {
        more_info: 'Más información',
        submit: 'Enviar',
        skip: 'Omitir',
        address_not_listed: 'Mi dirección no aparece en la lista',
        next: 'Siguiente',
        request_code: 'Solicitar código',
        request_another_code: 'Solicitar otro código',
        edit: 'Editar'
    }
}
